import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { illegalArgument } from '../../../base/common/errors.js';
import { UILabelProvider, AriaLabelProvider } from '../../../base/common/keybindingLabels.js';
import { ResolvedKeybinding, ResolvedKeybindingPart } from '../../../base/common/keyCodes.js';
export var BaseResolvedKeybinding = /*#__PURE__*/function (_ResolvedKeybinding) {
  _inherits(BaseResolvedKeybinding, _ResolvedKeybinding);

  var _super = _createSuper(BaseResolvedKeybinding);

  function BaseResolvedKeybinding(os, parts) {
    var _this;

    _classCallCheck(this, BaseResolvedKeybinding);

    _this = _super.call(this);

    if (parts.length === 0) {
      throw illegalArgument("parts");
    }

    _this._os = os;
    _this._parts = parts;
    return _this;
  }

  _createClass(BaseResolvedKeybinding, [{
    key: "getLabel",
    value: function getLabel() {
      var _this2 = this;

      return UILabelProvider.toLabel(this._os, this._parts, function (keybinding) {
        return _this2._getLabel(keybinding);
      });
    }
  }, {
    key: "getAriaLabel",
    value: function getAriaLabel() {
      var _this3 = this;

      return AriaLabelProvider.toLabel(this._os, this._parts, function (keybinding) {
        return _this3._getAriaLabel(keybinding);
      });
    }
  }, {
    key: "isChord",
    value: function isChord() {
      return this._parts.length > 1;
    }
  }, {
    key: "getParts",
    value: function getParts() {
      var _this4 = this;

      return this._parts.map(function (keybinding) {
        return _this4._getPart(keybinding);
      });
    }
  }, {
    key: "_getPart",
    value: function _getPart(keybinding) {
      return new ResolvedKeybindingPart(keybinding.ctrlKey, keybinding.shiftKey, keybinding.altKey, keybinding.metaKey, this._getLabel(keybinding), this._getAriaLabel(keybinding));
    }
  }, {
    key: "getDispatchParts",
    value: function getDispatchParts() {
      var _this5 = this;

      return this._parts.map(function (keybinding) {
        return _this5._getDispatchPart(keybinding);
      });
    }
  }]);

  return BaseResolvedKeybinding;
}(ResolvedKeybinding);